<h1 mat-dialog-title>Discard goods receipt?</h1>
<mat-dialog-actions align="end">
  <button class="mat-button" (click)="close()">Cancel</button>
  <button style="background-color: #ff6666" class="mat-raised-button" (click)="save()">Discard</button>
</mat-dialog-actions>
